import { useState } from "react";
import { PledgeModal, PledgeTable } from "../components";

export const PledgeDetails = () => {
  const [openPledgeModal, setOpenPledgeModal] = useState(false);
  const [pledge, setPledge] = useState(null);

  return (
    <>
      <PledgeModal
        isOpen={openPledgeModal}
        onClose={() => {
          setOpenPledgeModal(false);
          setPledge(null);
        }}
        data={pledge}
      />
      <PledgeTable
        onEdit={setPledge}
        onOpenModal={() => setOpenPledgeModal(true)}
      />
    </>
  );
};
